import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ChannelListModalPage } from './channel-list-modal.page';

const routes: Routes = [
	{
		path: '',
		component: ChannelListModalPage
	}
];

@NgModule({
	imports: [CommonModule, FormsModule, IonicModule, RouterModule.forChild(routes)],
	declarations: [ChannelListModalPage]
})
export class ChannelListModalPageModule {}
